import { Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { PaymentsService } from '../services/payments.service';
import { AccountService } from 'src/app/services/account.service';

export {
  Product, ProductSortType, productSortTypeToString,
  GetImage, GetSquaredImage, GetStripeId,
  lowToHigh, highToLow, DefaultProduct
} from 'src/app/models/product.model';

import { Product, ProductSortType, lowToHigh, highToLow } from 'src/app/models/product.model';
import { ProductComponent } from '../product/product.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-products-templated-list',
    templateUrl: './products-templated-list.component.html',
    styleUrls: ['./products-templated-list.component.css'],
    imports: [ProductComponent, FormsModule, NgClass]
})

export class ProductsTemplatedListComponent implements OnInit, OnChanges {

  error: Error;

  constructor(private paymentsService: PaymentsService, private accountService: AccountService) {
  }

  @Input()
  products: Array<Product> = [];

  @Input()
  productSortType: ProductSortType;

  productsRows: Array<Array<Product>> = [];

  @Input()
  itemsPerRow = 4;

  @Output() buyEvent = new EventEmitter<string>();

  Message: string;
  creatorCode: string;
  promotion_code: string;
  isWaitingReq = false;
  isValid = false;

  ngOnInit(): void {
    this.creatorCode = '';
    this.Message = '';
  }

  keyup(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    if (this.isWaitingReq) {
      target.value = this.creatorCode;
      return;
    }
    this.isValid = false;
    if (target.value.length == 0) {
      this.Message = ''
      return;
    }
    if (target.value.length > 6) {
      target.value = this.creatorCode ? this.creatorCode.toUpperCase() : '';
    }

    this.creatorCode = target.value.toUpperCase();

    if (this.creatorCode.length < 6) {
      target.value = this.creatorCode;
      this.Message = 'Creator Code is too short'
      this.isWaitingReq = false;
    }
    else {
      this.Message = 'Checking creator Code'
      this.accountService.checkCreatorCode(this.creatorCode).subscribe(
        (response) => {
          this.isWaitingReq = false;
          response = response.body
          this.promotion_code = response['promotion_code'];
          const percentOFF = response['promotion_prc']
          this.Message = 'This Creator Code is valid'
          this.isValid = true;
          this.UseCreatorCode(percentOFF);
        },
        (_error) => {
          this.isWaitingReq = false;
          this.Message = 'This Creator Code is not valid'
        }
      );
    }
  }

  UseCreatorCode(percentOFF: number) {
    if (!this.isValid)
      return;

    this.paymentsService.setCreatorCode(this.creatorCode, this.promotion_code, percentOFF);
    for (let i = 0; i < this.products.length; i++) {
      this.products[i].reduction = percentOFF;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('products' in changes || 'itemPerRow' in changes || 'productSortType' in changes) {
      const sortedProducts = this.products;
      sortedProducts.sort(this.productSortType === ProductSortType.PricesFromLowToHigh ? lowToHigh : highToLow)
      this.updateRows(sortedProducts);
    }
  }

  getNumberOfRows(): number {
    return Math.ceil(this.products.length / this.itemsPerRow);
  }

  private updateRows(newProducts: Array<Product>): void {
    const numberOfRows = this.getNumberOfRows()
    const newRows = Array<Array<Product>>(numberOfRows);
    for (let i = 0; i < numberOfRows; i++) {
      const newRow = Array<Product>();
      for (let j = 0; j < this.itemsPerRow && i * this.itemsPerRow + j < this.products.length; j++) {
        newRow.push(newProducts[i * this.itemsPerRow + j])
      }
      newRows[i] = newRow;
    }
    this.productsRows = newRows;
  }
}
